import { useState, useEffect } from 'react';
import { categoryName } from './helpers';

// Category-specific SVG illustration icons
export function CategoryIllustration({ category, className = 'category-ill-icon' }) {
  const norm = String(category || '').toLowerCase();

  if (norm.includes('wash')) {
    // Washing Machine
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="10" y="6" width="44" height="52" rx="7" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <line x1="10" y1="18" x2="54" y2="18" stroke="currentColor" strokeWidth="2" strokeDasharray="2 2" opacity="0.6" />
        <circle cx="20" cy="12" r="2.5" fill="var(--accent, #f5b800)" />
        <circle cx="28" cy="12" r="2" fill="currentColor" opacity="0.5" />
        <rect x="36" y="10" width="12" height="4" rx="2" fill="currentColor" opacity="0.4" />
        {/* Drum */}
        <circle cx="32" cy="38" r="14" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="32" cy="38" r="9" stroke="var(--accent, #f5b800)" strokeWidth="2" strokeDasharray="4 3" />
        <path d="M26 38C26 35 29 34 32 34C35 34 38 41 41 38" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (norm.includes('air') || norm.includes('ac')) {
    // Air Conditioner
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="8" y="14" width="48" height="24" rx="5" stroke="currentColor" strokeWidth="2.5" />
        <line x1="14" y1="26" x2="50" y2="26" stroke="currentColor" strokeWidth="2" opacity="0.5" />
        <circle cx="48" cy="20" r="2" fill="var(--accent, #f5b800)" />
        <path d="M16 44C20 49 26 49 30 44C34 39 40 39 44 44" stroke="var(--accent, #f5b800)" strokeWidth="2" strokeLinecap="round" opacity="0.8" />
        <path d="M20 50C24 55 28 55 32 50C36 45 42 45 46 50" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      </svg>
    );
  }

  if (norm.includes('phone') || norm.includes('mobile')) {
    // Smartphone
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="18" y="8" width="28" height="48" rx="6" stroke="currentColor" strokeWidth="2.5" />
        <line x1="28" y1="13" x2="36" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
        <circle cx="32" cy="49" r="2.5" fill="var(--accent, #f5b800)" />
        <rect x="23" y="18" width="18" height="26" rx="2" fill="currentColor" fillOpacity="0.08" />
      </svg>
    );
  }

  if (norm.includes('laptop') || norm.includes('computer')) {
    // Laptop
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="14" y="14" width="36" height="26" rx="3" stroke="currentColor" strokeWidth="2.5" />
        <path d="M8 46H56L51 42H13L8 46Z" stroke="currentColor" strokeWidth="2" fill="currentColor" fillOpacity="0.1" />
        <circle cx="32" cy="27" r="4" fill="var(--accent, #f5b800)" fillOpacity="0.8" />
      </svg>
    );
  }

  if (norm.includes('audio') || norm.includes('headphone') || norm.includes('sound')) {
    // Audio / Headphones
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M14 36V28C14 18.0589 22.0589 10 32 10C41.9411 10 50 18.0589 50 28V36" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="10" y="34" width="8" height="18" rx="4" stroke="currentColor" strokeWidth="2" fill="var(--accent, #f5b800)" fillOpacity="0.3" />
        <rect x="46" y="34" width="8" height="18" rx="4" stroke="currentColor" strokeWidth="2" fill="var(--accent, #f5b800)" fillOpacity="0.3" />
      </svg>
    );
  }

  if (norm.includes('wear') || norm.includes('watch')) {
    // Watch / Wearable
    return (
      <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="24" y="6" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="2" fill="currentColor" fillOpacity="0.1" />
        <rect x="24" y="46" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="2" fill="currentColor" fillOpacity="0.1" />
        <rect x="18" y="16" width="28" height="32" rx="8" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="32" cy="32" r="8" stroke="var(--accent, #f5b800)" strokeWidth="1.5" />
      </svg>
    );
  }

  // General Tech Chip fallback
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="16" y="16" width="32" height="32" rx="6" stroke="currentColor" strokeWidth="2.5" fill="currentColor" fillOpacity="0.05" />
      <circle cx="32" cy="32" r="6" fill="var(--accent, #f5b800)" />
      <line x1="16" y1="24" x2="8" y2="24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="32" x2="8" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="40" x2="8" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="48" y1="24" x2="56" y2="24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="48" y1="32" x2="56" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="48" y1="40" x2="56" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function getProductInitials(title = '') {
  const words = String(title || '')
    .trim()
    .replace(/[^\w\s]/g, '')
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return 'TM';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/**
 * Robust ProductImage with:
 * - Loading skeleton shimmer
 * - Automatic onError fallback
 * - Illustrated placeholder with category icon + initials
 */
export function ProductImage({
  src,
  alt = '',
  title = '',
  category = '',
  className = '',
  onClick,
  loading = 'lazy',
  priority = false,
}) {
  const [loadState, setLoadState] = useState('initial'); // 'initial' | 'loaded' | 'error'

  useEffect(() => {
    setLoadState('initial');
  }, [src]);

  const hasSrc = Boolean(src && typeof src === 'string' && src.trim());
  const initials = getProductInitials(title);
  const catLabel = categoryName(category);

  if (!hasSrc || loadState === 'error') {
    return (
      <div
        className={`product-fallback-placeholder ${className}`}
        role="img"
        aria-label={alt || title || 'Product image placeholder'}
        onClick={onClick}
      >
        <div className="placeholder-pattern-bg" aria-hidden="true" />
        <div className="placeholder-content">
          <CategoryIllustration category={category} className="placeholder-cat-icon" />
          <span className="placeholder-badge">
            <b className="placeholder-initials">{initials}</b>
            <span className="placeholder-cat-name">{catLabel}</span>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`product-img-wrapper ${loadState === 'initial' ? 'is-loading' : 'is-loaded'} ${className}`} onClick={onClick}>
      {loadState === 'initial' && <span className="product-img-skeleton" aria-hidden="true" />}
      <img
        src={src}
        alt={alt || title}
        loading={priority ? 'eager' : loading}
        fetchPriority={priority ? 'high' : 'auto'}
        className="product-img-element"
        onLoad={() => setLoadState('loaded')}
        onError={() => setLoadState('error')}
      />
    </div>
  );
}
